var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attach",
    clipPath: "url(#clip0_9972_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6406 1.88615C10.8157 1.40992 9.76104 1.69163 9.27922 2.52615L4.1354 11.4355C3.31038 12.8645 3.80064 14.6803 5.21229 15.4953C6.62922 16.3133 8.44464 15.8217 9.2666 14.398L13.6898 6.73682C13.8969 6.3781 14.3556 6.2552 14.7143 6.4623C15.073 6.66941 15.1959 7.1281 14.9888 7.48682L10.5656 15.148C9.33339 17.2823 6.60344 18.0305 4.46229 16.7943C2.33017 15.5633 1.59888 12.8289 2.83636 10.6855L7.98019 1.77615C8.87337 0.229102 10.8434 -0.306163 12.3906 0.587109C13.9378 1.48038 14.4592 3.4541 13.5661 5.00115L9.26296 12.4543C8.71352 13.406 7.49968 13.737 6.5455 13.1861C5.59132 12.6352 5.27107 11.4185 5.82051 10.4668L9.40297 4.26182C9.61007 3.9031 10.0688 3.7802 10.4275 3.9873C10.7862 4.19441 10.9091 4.6531 10.702 5.01182L7.11955 11.2168C6.98149 11.4559 7.06366 11.7532 7.2955 11.8871C7.52734 12.0209 7.82586 11.9434 7.96392 11.7043L12.267 4.25115C12.7488 3.41663 12.4654 2.36237 11.6406 1.88615Z",
    fill: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9972_1087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.1e17a519be8d0621d1bca034261ce050.svg";
export { ForwardRef as ReactComponent };